import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import LoginForm from "../components/auth/LoginForm";
import RegisterForm from "../components/auth/RegisterForm";
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm";
import "./AuthPage.css";

const authViewFromQuery = (view) => (
  view === "register" || view === "forgot-password" ? view : "login"
);

const AuthPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState(() => (
    authViewFromQuery(searchParams.get("view"))
  ));
  const message = searchParams.get("message");

  useEffect(() => {
    setCurrentView(authViewFromQuery(searchParams.get("view")));
  }, [searchParams]);

  const switchView = (view) => {
    const nextView = authViewFromQuery(view);
    setCurrentView(nextView);
    const next = new URLSearchParams(searchParams);
    if (nextView === "login") {
      next.delete("view");
    } else {
      next.set("view", nextView);
    }
    setSearchParams(next, { replace: true });
  };

  const switchToLogin = () => switchView("login");
  const switchToRegister = () => switchView("register");
  const switchToForgotPassword = () => switchView("forgot-password");

  return (
    <Layout>
      <div className="auth-page-simple">
        <div className="auth-container-simple">
          {message && <p className="auth-notice">{message}</p>}
          {currentView === "login" && (
            <LoginForm
              onSwitchToRegister={switchToRegister}
              onSwitchToForgotPassword={switchToForgotPassword}
            />
          )}
          {currentView === "register" && (
            <RegisterForm onSwitchToLogin={switchToLogin} />
          )}
          {currentView === "forgot-password" && (
            <ForgotPasswordForm onSwitchToLogin={switchToLogin} />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default AuthPage;
